import { Injectable } from '@angular/core';

/**
 * Something whose tab-local table UI state (search term, active filters, …) can be reset,
 * e.g. a {@link BcmBaseFacade}.
 */
export interface BcmFacadeTableUiResetTarget {
    resetTableUiState(): void;
}

/**
 * Registry of table UI reset targets, used to clear tab-local state on a harbour switch.
 *
 * It lives as its own root-provided service (rather than being a method on BcmBaseFacade) so that
 * BcmTenantChangeResetService / BcmService can trigger a reset without importing BcmBaseFacade,
 * which would create a circular module import with BcmService.
 */
@Injectable({ providedIn: 'root' })
export class FacadeTableUiRegistry {

    private readonly _targets = new Set<BcmFacadeTableUiResetTarget>();

    /** Registers a target and returns a disposer that removes it again. */
    register(target: BcmFacadeTableUiResetTarget): () => void {
        this._targets.add(target);

        return () => {
            this._targets.delete(target);
        };
    }

    resetAll(): void {
        this._targets.forEach(target => target.resetTableUiState());
    }
}
